import { useCallback } from "react";

const useOnPageSelection = (dispatch, RemToPx) => {
  const onPageSelection = useCallback(
    ({ pageIndex, widgetID }) => {
      dispatch({ activePageIndex: pageIndex, KPIWiseConfigs: null });
      setTimeout(() => {
        const widgetElement = document.querySelector(`[data-widget-id="${widgetID}"]`);
        if (widgetElement) {
          const offset = RemToPx(20);
          const bodyRect = document.body.getBoundingClientRect().top;
          const elementRect = widgetElement.getBoundingClientRect().top;
          const elementPosition = elementRect - bodyRect;
          const offsetPosition = elementPosition - offset;
          window.scrollTo({
            top: offsetPosition,
          });
        }
      }, 0);
    },
    [dispatch, RemToPx]
  );
  return onPageSelection;
};

const useSetGlobalFilters = (dispatch) => {
  const setGlobalFilters = useCallback(
    (selectedGlobalFilter) => {
      dispatch((state) => ({
        selectedGlobalFilter:
          state.selectedGlobalFilter == null
            ? selectedGlobalFilter
            : selectedGlobalFilter.filterID == state.selectedGlobalFilter.filterID
            ? null
            : selectedGlobalFilter,
      }));
    },
    [dispatch]
  );
  return setGlobalFilters;
};

export { useOnPageSelection, useSetGlobalFilters };
